'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import {
  consumeReachedEpo,
  gtmEventForClickTarget,
  pushGtmEvent,
  GTM_EVENTS,
} from 'lib/gtm';

/** Pushes the agency's GTM conversion names for button clicks and the EPO page. */
export default function GtmConversions() {
  const pathname = usePathname();

  useEffect(() => {
    if (consumeReachedEpo(pathname)) {
      pushGtmEvent(GTM_EVENTS.reachedEpo);
    }
  }, [pathname]);

  useEffect(() => {
    const onClick = (event: MouseEvent) => {
      const name = gtmEventForClickTarget(event.target);
      if (name) pushGtmEvent(name);
    };

    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, []);

  return null;
}
